import { ImageMetadataApiModel } from '../../../api/mentions/model/image-metadata.api.model';
import * as _ from 'underscore';
import { imageMetadataTypesApiEnum } from '../../../api/mentions/enum/image-metadata-types.api.enum';
import { basicClone, Clonable } from '../../Basic/decorators/clone.decorator';

export class ImageKeywordModel {
    @Clonable()
    description: string;
    @Clonable()
    type: imageMetadataTypesApiEnum;

    constructor(apiEntity?: ImageMetadataApiModel) {
        const hasApiEntity: boolean = apiEntity !== null && typeof apiEntity === 'object';

        if (hasApiEntity) {
            this.constructFromApiEntity(apiEntity);
        } else {
            this.constructDefault();
        }
    }

    /**
    * Constructs this model from the corresponding API entity
    */
    private constructFromApiEntity(apiEntity: ImageMetadataApiModel): void {
        this.type = apiEntity.type;
        this.description = apiEntity.description;
    }

    /**
    * Constructs the default version of this model
    */
    private constructDefault(): void {
        this.type = imageMetadataTypesApiEnum.label;
        this.description = '';
    }

    public toApiEntity(): ImageMetadataApiModel {
        return {
            description: this.description,
            type: this.type
        } as ImageMetadataApiModel;
    }

    public clone(): ImageKeywordModel {
        return basicClone(this);
    }
}
